import { render, staticRenderFns } from "./LikertScale.vue?vue&type=template&id=dac35f54&scoped=true"
import script from "./LikertScale.vue?vue&type=script&lang=js"
export * from "./LikertScale.vue?vue&type=script&lang=js"
import style0 from "./LikertScale.vue?vue&type=style&index=0&id=dac35f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac35f54",
  null
  
)

export default component.exports